export const validCoordinates = value => {
    if (!value) return false;
    const latitude = Number(value.latitude);
    const longitude = Number(value.longitude);
    return Number.isFinite(latitude) && latitude >= -90 && latitude <= 90 && Number.isFinite(longitude) && longitude >= -180 && longitude <= 180;
};

export const locationErrorText = error => {
    if (typeof error === "string") return error;
    if (error?.message) return error.message;
    return "暂时无法获取定位，请检查浏览器定位权限";
};

export const getBrowserLocation = () => new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
        reject(new Error("当前浏览器不支持定位，可以手动填写地图坐标"));
        return;
    }
    const localHost = ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);
    if (!window.isSecureContext && !localHost) {
        reject(new Error("一键精确定位需要使用HTTPS打开网站；当前可手动填写地图坐标"));
        return;
    }
    navigator.geolocation.getCurrentPosition(
        position => resolve({
            latitude: Number(position.coords.latitude.toFixed(7)),
            longitude: Number(position.coords.longitude.toFixed(7)),
            accuracy: Math.round(position.coords.accuracy || 0)
        }),
        error => {
            const messages = { 1: "定位权限被拒绝，请在浏览器设置中允许定位", 2: "暂时无法确定当前位置，请稍后再试", 3: "获取位置超时，请重试" };
            reject(new Error(messages[error.code] || "获取定位失败"));
        },
        { enableHighAccuracy: true, timeout: 8000, maximumAge: 300000 }
    );
});
